import Chart from "chart.js";
import { ApiResponse } from "@/api/types";

export enum CHART_TYPE {
  WEEKLY = "WEEKLY",
  MONTHLY = "MONTHLY"
}

export enum TARGET_KEY {
  INCREMENTS = "increments",
  TOTAL = "total"
}

type ChartType = CHART_TYPE.WEEKLY | CHART_TYPE.MONTHLY;

export interface ExChartOptions extends Chart.ChartOptions {
  cornerRadius?: number;
}

export interface Props {
  type: ChartType;
  report: ApiResponse.Report;
}
export interface Data {
  bindTo: string;
  chart: Chart | null;
  chartData: Chart.ChartData;
  chartOptions: ExChartOptions;
}
export interface Computed {}
export interface Methods {
  generateChart: () => void;
  generateData: (
    reports: ApiResponse.NestedReport[]
  ) => { incrementsData: number[]; totalData: number[] };
  generateLabels: (reports: ApiResponse.NestedReport[]) => string[];
  customDrawInit: () => void;
  onChangeChartData: () => void;
  onChangeReport: (report: ApiResponse.Report) => void;
  findMaxValueForTicks: (data: number[]) => [number, number];
}
